import { Component, input } from '@angular/core';
import { Customer, Building, Application, Mortgage, DocumentType, Task } from '@app/core/stingray-api/models';
import { DocumentsService, CustomersService } from '@app/core/stingray-api/services';
import { Subject } from 'rxjs';
import { FilesService } from '../files.service';
import { TranslateModule } from '@ngx-translate/core';
import { FilesTabComponent } from '../files-tab/files-tab.component';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
    selector: 'unite-file-object-tab',
    templateUrl: './file-object-tab.component.html',
    styleUrls: ['./file-object-tab.component.scss'],
    imports: [FileUploadComponent, FilesTabComponent, TranslateModule]
})
export class FileObjectTabComponent {

  customer = input<Customer>();
  objectType = input<'Building' | 'Mortgage' | 'Customer' | 'Other' | 'Application' | 'All' | 'Task'>();
  object = input<Building | Mortgage | Application | Task>();
  uploadButtonText = input<string>();

  loadDocument: Subject<'Building' | 'Mortgage' | 'Customer' | 'Other' | 'Application' | 'All' | 'Task'> = new Subject();

  init = false;

  customers: Customer[] = [];
  documentTypes: DocumentType[] = [];
  buildings: Building[] = [];
  applications: Application[] = [];
  mortgages: Mortgage[];

  constructor(private filesService: FilesService,
    private documentsService: DocumentsService,
    private customersService: CustomersService) { }


  /**
   * New file submitted
   */
  newFile() {
    this.loadDocument.next(this.objectType());
  }

  documentsInit() {
    this.filesService.getRelatedCustomers(this.customer()).subscribe((customers: Customer[]) => {
      this.customers = customers;
    });

    this.documentsService.getDocumentTypes().subscribe((documentTypes: DocumentType[]) => {
      this.documentTypes = this.filesService.removeInrelevantDocumentTypes(this.customer(), documentTypes);
    });

    this.customersService.getCustomerBuildingsById({
      id: this.customer().id,
      includeMortgages: false,
      includeRenovations: false
    }).subscribe((buildings: Building[]) => {
      this.buildings = buildings;
    });

    this.customersService.getCustomerApplicationsById({
      id: this.customer().id
    }).subscribe((applications: Application[]) => {
      this.applications = applications;
    });

    this.customersService.getCustomerMortgagesById({
      id: this.customer().id,
      statuses: ['Active']
    }).subscribe((mortgages: Mortgage[]) => {
      this.mortgages = mortgages;
    });

    this.loadDocument.next(this.objectType());
  }
}
